/**
 * Composant de chargement optimisé pour React.lazy()
 * Affichage minimal pour éviter le CLS
 */

import { memo } from 'react';

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        {/* Spinner optimisé CSS uniquement */}
        <div className="w-12 h-12 border-4 border-teal-100 border-t-teal-600 rounded-full animate-spin" />
        <p className="text-sm text-gray-500 font-medium">Chargement...</p>
      </div>
    </div>
  );
}

export default memo(LoadingFallback);